/**
 * STACKED_GROUPED_COLUMN_CHART_SCHEMA: a JSON object representing a schema used to drive the chart
 * in the desktop view of the scenario analysis section.
 */
export const STACKED_GROUPED_COLUMN_CHART_CONFIG = {
	chart: {
		style: {
			fontFamily: '"FortBook", Arial, sans-serif',
			color: '#616161'
		},
		type: 'column'
	},

	plotOptions: {
		series: { stacking: 'normal' },
		column: {
			pointWidth: '25',
			groupPadding: 0.85,
			pointPadding: 0
		}
	},
	xAxis: {
		min: 0,
		title: {
			text: 'Scenarios',
			style: {
				color: '#000',
				font: '12px "FortBook", Arial, sans-serif'
			},
			margin: 40
		},
		labels: {
			style: {
				color: '#616161',
				font: '12px "FortBook", Arial, sans-serif'
			}
		}
	},
	yAxis: {
		title: {
			text: 'Sensitivity %',
			style: {
				color: '#000',
				font: '12px "FortBook", Arial, sans-serif'
			},
			margin: 40
		},
		categories: null
	},
	colors: null,
	extensibleData: null
};
